import { useMutation } from 'react-query';

import Api from '../../api/api';
import { SubCategoryDto } from '../../sub-category/hooks';

export type CategoryCreateDTO = {
  title: string;
  media?: any;
  published: boolean;
  subCategory?: SubCategoryDto[];
};

export const createCategory = async (params: CategoryCreateDTO) => {
  const [response, bodyOrError] = await Api.post('categories', params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useCreateCategory = () => useMutation('createCategory', createCategory);
